import React from 'react';

import TenantConfig from '../../config';
import { formatUSDCurrency } from '../../helpers/format';

const OfferDetail = ({ features }) => {
  if (!features || !TenantConfig?.dashboard.renderOfferDetail) {
    return '';
  }
  const offerProperty = features.find((feature) => feature.itemType === 'OfferProperty');
  let offer = {};
  if (offerProperty) {
    offer.minApr = offerProperty.value.minApr;
    offer.maxApr = offerProperty.value.maxApr;
    offer.maxAmount = offerProperty.value.maxAmount;
  }
  return offer && offerProperty ? (
    <div className="offer-detail">
      {offer.minApr === offer.maxApr ? offer.minApr : `${offer.minApr} - ${offer.maxApr}`} % APR up
      to {formatUSDCurrency(offer.maxAmount)}
    </div>
  ) : (
    ''
  );
};

export default OfferDetail;
